<template>
  <div v-if="mainCategoryBannerImageUrl">
    <component :is="linkConfig.element" v-bind="linkConfig.attrs">
      <picture>
        <source
          v-if="desktopCategoryBannerImageUrl"
          :srcset="lexasSrcset(desktopCategoryBannerImageUrl, DESKTOP_WIDTHS, desktopImage.width) || desktopCategoryBannerImageUrl"
          sizes="100vw"
          :width="desktopImage.width"
          :height="desktopImage.height"
          media="(min-width: 1024px)"
        >
        <img
          :src="lexasImage(mainCategoryBannerImageUrl)"
          :srcset="lexasSrcset(mainCategoryBannerImageUrl, MOBILE_WIDTHS, mobileImage.width) || undefined"
          sizes="100vw"
          :width="mobileImage.width"
          :height="mobileImage.height"
          :alt="altText"
          class="h-auto"
        >
      </picture>
    </component>
  </div>
</template>

<script setup>
import { useLexas } from '~/composables/useLexas'
import { lexasImage, lexasSrcset } from '~/helpers/lexasImage'

const MOBILE_WIDTHS = [400, 640, 828]
const DESKTOP_WIDTHS = [1024, 1280, 1536, 1920]

const route = useRoute()
const { getCategoryBannerListByPath } = useLexas()
// Fetch hero banners based on route path
const banners = await getCategoryBannerListByPath(route.path)

const { mobileImage = {}, desktopImage = {}, link = '' } = banners?.[0] || {}
const mainCategoryBannerImageUrl = computed(() => mobileImage.url || '')
const desktopCategoryBannerImageUrl = computed(() => desktopImage?.url || '')
const altText = computed(() => mobileImage?.altText || desktopImage?.altText || '')

// Check if the link is an external
const isExternal = computed(() => /^(http|https):\/\//.test(link))
const NuxtLink = resolveComponent('NuxtLink')

const linkConfig = computed(() => {
  return link
    ? isExternal.value
      // If the link is external, use an anchor tag with target and rel attributes
      ? { element: 'a', attrs: { href: link, target: '_blank', rel: 'noopener noreferrer' } }
      // If the link is internal, use NuxtLink
      : { element: NuxtLink, attrs: { to: link } }
    // If there's no link, return a div
    : { element: 'div', attrs: {} }
})
</script>
